import { BEFORE_APP, SET_RATE, SET_ANN, APP_MODE } from './redux/types';
import { emptyError } from './redux/shared/error/error.action';
import axios from 'axios';
import { ENV } from './config/config';


export const beforeApp = () => {
    return {
        type: BEFORE_APP
    }
};

export const getRate = (id) => dispatch => {
    dispatch(emptyError());
    axios.get(ENV.dollar + `?id=${id}`).then((res) => {
        if (res) {
            dispatch({
                type: SET_RATE,
                payload: res.data[0].price_usd
            })
        }
    })
};

export const getAnnRate = () => dispatch => {
    dispatch(emptyError());
    axios.get(ENV.ann).then((res) => {
        if (res) {
            dispatch({
                type: SET_ANN,
                payload: res.data.market_data.current_price.usd
            })
        }
    })
};

export const setMenu = (menuType = 1) => dispatch => {
    dispatch(emptyError());
    dispatch({
        type: APP_MODE,
        payload: menuType
    })
};